import { BaseService } from '../../../../../core/services/base.service';
import { getApiBaseUrl } from '../../../../../core/config/runtimeConfig';
import { Company, File } from '../models/company-profile.model';
import { useAuthStore } from "../../../../../core/store/auth.store";

export class CompanyService {
  static async Get(id: string): Promise<Company> {
    return await BaseService.Get(`/companies/${id}`);
  }

  static async Post(company: Company): Promise<Company> {
    return await BaseService.Post('/companies', {
      name: company.name,
      website: company.website,
      aboutUs: company.aboutUs,
    });
  }

  static async Patch(id: string, company: Company): Promise<void> {
    await BaseService.Patch(`/companies/${id}`, {
      name: company.name,
      website: company.website,
      aboutUs: company.aboutUs,
    });
  }

  static async GetFile(companyId: string): Promise<Blob> {
    const auth = useAuthStore.getState().getAuth();
    const response = await fetch(
      `${getApiBaseUrl()}/companies/${companyId}/files`,
      {
        headers: {
          Authorization: `bearer ${auth?.accessToken.accessToken}`,
        },
      }
    );
    if (!response.ok) throw new Error("Failed to fetch file");
    return await response.blob();
  }



  static async PatchFile(
    companyId: string,
    file: globalThis.File
  ): Promise<File> {
    const formData = new FormData();
    formData.append('file', file);
    return await BaseService.Patch(`/companies/${companyId}/files`, formData);
  }

  static async DeleteFile(companyId: string, fileId: string): Promise<File> {
    return await BaseService.Delete(`/companies/${companyId}/files/${fileId}`);
  }
}
